export default __webpack_public_path__ + "static/Canela-LightItalic-efd03310c6342e4d822d15c9f276b1b6.woff";